export const changeLocalization = payload => ({
  type: 'CHANGE_LOCALIZATION',
  payload,
});

export const setLocalizationLoading = payload => ({
  type: 'SET_LOCALIZATION_LOADING',
  payload,
});
